module.exports = __webpack_public_path__ + "img/location2.0f6c5e8d.svg";